import React from "react";
import { MdOutlineAddCircleOutline } from 'react-icons/md';
import EditDynamicWeightPriceRange from "./edit-dynamic-weight-price-range";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { addDynamicWeightPriceRange, selectDynamicWeight, selectSecuritySelected } from "./edit-position-slice";
import { isFund } from "../../../../app/utils";

const EditDynamicWeight: React.FC = () => {
  // Get the 'dispatch' method from the store
  const dispatch = useAppDispatch();
  const dynamicWeight = useAppSelector(selectDynamicWeight);
  const securitySelected = useAppSelector(selectSecuritySelected);
  const priceStep = isFund(securitySelected?.assetType) ? 1e-7 : 0.01;

  const addDynamicWeightPriceRangeHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    dispatch(addDynamicWeightPriceRange());
  }

  return (
    <div className="flex flex-col p-2 rounded-lg border border-neutral-400 bg-yellow-300/10">
      <div className="w-full grid grid-cols-12 my-2">
        <div className="col-span-9 text-center">
          Faixa de Preço
        </div>
        <div className="col-span-3 text-center">
          Peso
        </div>
        {
          dynamicWeight && dynamicWeight.weightPriceRanges &&
          dynamicWeight.weightPriceRanges.map((priceRange, index) => {
            let priceMin = 0;
            if (index > 0) {
              const previousPriceRange = dynamicWeight.weightPriceRanges.at(index - 1);
              priceMin = previousPriceRange ? (previousPriceRange.priceMax + priceStep) : 0;
            }
            return <EditDynamicWeightPriceRange
              key={`DynamicWeightPriceRange_${index}`}
              arrayIndex={index}
              priceMin={priceMin}
              priceStep={priceStep}
              dynamicWeightPriceRange={priceRange} />
          })
        }
      </div>
      <div onClick={addDynamicWeightPriceRangeHandler} className='cursor-pointer flex flex-row w-fit self-center items-center justify-center px-3 py-1 text-yellow-300 rounded-full bg-slate-800 disabled:cursor-default disabled:bg-gray-400 hover:enabled:opacity-85 hover:enabled:shadow-lg hover:enabled:border-slate-600 hover:enabled:border-1'>
        <MdOutlineAddCircleOutline size={20} className="mr-1" />
        Nova Faixa
      </div>
    </div>
  )
}

export default EditDynamicWeight;